import ShareDocumentModal from '@/components/ShareDocumentModal';
import { SHARE_MODAL_TYPES } from '@/store/editor';

function SendDocumentModal({ open, onOpenChange, selectedTransactions }) {
	return (
		<ShareDocumentModal
			defaultFileName={selectedTransactions?.[0]?.metadata?.originalFileName}
			id={selectedTransactions?.[0]?.id}
			onOpenChange={onOpenChange}
			open={open}
			type={SHARE_MODAL_TYPES.SEND_BY_EMAIL}
		/>
	);
}

export default SendDocumentModal;
